var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dynamicValidateForm",
          staticClass: "COrder-dynamic",
          attrs: { model: _vm.dynamicValidateForm, "label-width": "240px" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "appId",
                label: _vm.$t("appName") + "：",
                rules: [
                  {
                    required: true,
                    message: _vm.$t("payment.pleaseChooseApp"),
                    trigger: "blur",
                  },
                  {
                    type: "string",
                    message: _vm.$t("payment.pleaseChooseApp"),
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("ticket.select"),
                  },
                  model: {
                    value: _vm.dynamicValidateForm.appId,
                    callback: function ($$v) {
                      _vm.$set(_vm.dynamicValidateForm, "appId", $$v)
                    },
                    expression: "dynamicValidateForm.appId",
                  },
                },
                _vm._l(_vm.appList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "mtNO",
                label: _vm.$t("payment.merchantTradeNo") + "：",
              },
            },
            [
              _c("el-input", {
                attrs: { value: _vm.dynamicValidateForm.mtNO, disabled: true },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "currency", label: _vm.$t("t.currency") + "：" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    filterable: "",
                    placeholder: _vm.$t("ticket.select"),
                  },
                  model: {
                    value: _vm.dynamicValidateForm.currency,
                    callback: function ($$v) {
                      _vm.$set(_vm.dynamicValidateForm, "currency", $$v)
                    },
                    expression: "dynamicValidateForm.currency",
                  },
                },
                _vm._l(_vm.currencyList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item, value: item },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "orderAmount",
                label: _vm.$t("tables.listing.recurring_order_amount") + "：",
                rules: [
                  {
                    required: true,
                    message: _vm.$t("payment.pleaseEnterOrderAmount"),
                    trigger: "blur",
                  },
                  {
                    type: "string",
                    message: _vm.$t("payment.pleaseEnterCorrectOrderAmount"),
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.dynamicValidateForm.orderAmount,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dynamicValidateForm,
                      "orderAmount",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dynamicValidateForm.orderAmount",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "email",
                label: _vm.$t("auth.email") + "：",
                rules: [
                  {
                    required: true,
                    message: _vm.$t("payment.pleaseEnterEmail"),
                    trigger: "blur",
                  },
                  {
                    type: "email",
                    message: _vm.$t("payment.pleaseEnterCorrectEmail"),
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.dynamicValidateForm.email,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dynamicValidateForm,
                      "email",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dynamicValidateForm.email",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "subject",
                label: _vm.$t("subject") + "：",
                rules: [
                  {
                    required: true,
                    message: _vm.$t("payment.pleaseEnterSubject"),
                    trigger: "blur",
                  },
                  {
                    type: "string",
                    message: _vm.$t("payment.pleaseEnterCorrectSubject"),
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.dynamicValidateForm.subject,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dynamicValidateForm,
                      "subject",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dynamicValidateForm.subject",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "content",
                label: _vm.$t("payment.content") + "：",
                rules: [
                  {
                    required: true,
                    message: _vm.$t("payment.pleaseEnterContent"),
                    trigger: "blur",
                  },
                  {
                    type: "string",
                    message: _vm.$t("payment.pleaseEnterCorrectContent"),
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.dynamicValidateForm.content,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dynamicValidateForm,
                      "content",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dynamicValidateForm.content",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "returnUrl",
                label: _vm.$t("payment.returnUrl") + "：",
                rules: [
                  {
                    required: true,
                    message: _vm.$t("payment.pleaseEnterReturnUrl"),
                    trigger: "blur",
                  },
                  {
                    type: "url",
                    message: _vm.$t("payment.pleaseEnterCorrectReturnUrl"),
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                model: {
                  value: _vm.dynamicValidateForm.returnUrl,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dynamicValidateForm,
                      "returnUrl",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dynamicValidateForm.returnUrl",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "expireTime",
                label: _vm.$t("payment.expireTimeMinutes") + "：",
                rules: [
                  {
                    required: true,
                    message: _vm.$t("payment.pleaseEnterContent"),
                    trigger: "blur",
                  },
                ],
              },
            },
            [
              _c("el-input-number", {
                attrs: { type: "number", min: 90 },
                model: {
                  value: _vm.dynamicValidateForm.expireTime,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.dynamicValidateForm,
                      "expireTime",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "dynamicValidateForm.expireTime",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "100%", height: "40px" },
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("dynamicValidateForm")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("basic.button.submit")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "vuestic-modal",
        {
          ref: "paymentLink",
          staticClass: "change-email-show",
          staticStyle: { height: "100%", width: "60vw" },
          attrs: {
            "show.sync": "true",
            okText: _vm._f("translate")("modal.confirm2"),
            okClass: "btn btn-primary btn-micro",
            cancelClass: "btn btn-secondary btn-micro",
            cancelText: _vm._f("translate")("modal.cancel2"),
            alignModal: "",
            noButtons: "",
          },
          on: { cancel: _vm.cancelPaymentLink },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("payment.paymentLink"))),
          ]),
          _c("div", [
            _c("form", [
              _c("div", { staticClass: "va-row mb-5" }, [
                _c("div", { staticClass: "flex xs12 md8" }, [
                  _c(
                    "div",
                    { staticClass: "form-group with-icon-right mb-0" },
                    [
                      _c("div", { staticClass: "input-group" }, [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.orderUrl,
                              expression: "orderUrl",
                            },
                          ],
                          attrs: {
                            id: "companyNameInput",
                            name: "companyName",
                            disabled: true,
                            rows: "3",
                          },
                          domProps: { value: _vm.orderUrl },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.orderUrl = $event.target.value
                            },
                          },
                        }),
                        _c("i", { staticClass: "bar" }),
                      ]),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "flex xs12 md4",
                    staticStyle: { "align-self": "end", "text-align": "right" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-create-order",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.copyUrl.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "btn-with-icon-content" }, [
                          _c("i", { staticClass: "ion-md-copy ion" }),
                          _vm._v(_vm._s(_vm.$t("payment.copyUrl"))),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "va-row mb-4" }, [
                _c("div", { staticClass: "flex xs12 md7 text-center" }, [
                  _c("img", {
                    staticClass: "order-qr-code",
                    attrs: { src: _vm.qrCodeUrl, alt: "qrcode" },
                  }),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "flex xs12 md5",
                    staticStyle: { "align-self": "end", "text-align": "right" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-create-order",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                            return _vm.copyQRCode.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "btn-with-icon-content" }, [
                          _c("i", { staticClass: "ion-md-copy ion" }),
                          _vm._v(_vm._s(_vm.$t("payment.copyQrcode"))),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }